var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"empty"}),_c('div',{staticClass:"position-absolute bottom",staticStyle:{"left":"37%"}},[_c('h3',[_vm._v("空空如也")])])])
}]

export { render, staticRenderFns }